import { Provider } from "react-redux";
import { store } from "../slices";
import { PropsWithChildren } from "react";

export function StoreProvider({children}: PropsWithChildren){
    return (
        <Provider store={store}>
            {children}
        </Provider>
    )
}